import MESSAGE_TARGETS from './constants/signalRMessageTargets';
import useSignalRSubscription from './useSignalRSubscription';
import { showToastNotification } from './subscriptions/showToastNotification';
import { useEndMashboardSession } from './subscriptions/useEndMashboardSession';
import { useEvitCache } from './hooks/useEvitCache';
import { useIncrementNotificationCounter } from './hooks/useIncrementNotificationCounter';

export const SignalRSubscriptions = () => {
  const endMashboardSession = useEndMashboardSession();
  const clearCache = useEvitCache();
  const incrementNotificationCounter = useIncrementNotificationCounter();

  useSignalRSubscription(MESSAGE_TARGETS.USER_SESSION_ENDED, endMashboardSession);
  useSignalRSubscription(MESSAGE_TARGETS.TOAST_NOTIFICATION, incrementNotificationCounter);
  useSignalRSubscription(MESSAGE_TARGETS.TOAST_NOTIFICATION, notification =>
    showToastNotification(notification, clearCache)
  );

  return null;
};
